import { aadConfig, getAccessToken } from '@services/aad';
import apiProxy from '@services/api/apiProxy';
import axios from 'axios';

export const getByLinks = apiProxy('getByLinks', async (links: string[]): Promise<Record<string, unknown>> => {
  await getAccessToken(aadConfig().accountScopes);

  const ops = links.map(async (link) => {
    try {
      return await axios.get(link);
    } catch {
      return { data: null };
    }
  });

  const result: Record<string, unknown> = {};

  const items = await Promise.all(ops);
  for (let i = 0; i < links.length; i++) {
    result[links[i]] = items[i].data;
  }

  return result;
});
